import {
  getDeviceType,
  sendAmplitudeEvent,
} from '@html/_common/utils';

export default function NavigationTabs(navigationHandler) {
  const NAVIGATION_TABS_CONTAINER = '.ao-tour-navigation-tabs';
  const NAVIGATION_TAB_SELECTOR = '.js-navigation-tab-selector__button';
  const NAVIGATION_TAB_STICKY_CLASS = '.ao-tour-navigation-tabs--sticky';
  const NAVIGATION_TAB_PARENT_CLASS = '.am-switch__tab';
  const NAVIGATION_TAB_ACTIVE_CLASS = '.am-switch__marker';
  const NAVIGATION_TAB_SWITCH_CLASS = '.ao-tour-navigation-tabs .am-switch__wrapper';
  const NAVIGATION_TABS_LEFT_ARROW_CLASS = '.am-switch__arrow-left';
  const NAVIGATION_TABS_RIGHT_ARROW_CLASS = '.am-switch__arrow-right';
  const PARENT_SELECTOR = '.bl.bl--middle';

  // const AMP_EVENT_NAME = 'tdp_tabs_clicked';

  const $navigationTabs = $(NAVIGATION_TAB_SELECTOR);
  const $parentElement = $(PARENT_SELECTOR);
  const $navWrapper = $(NAVIGATION_TABS_CONTAINER);
  const $switchWrapper = $(NAVIGATION_TAB_SWITCH_CLASS);
  const $leftNavigationArrow = $(NAVIGATION_TABS_LEFT_ARROW_CLASS);
  const $rightNavigationArrow = $(NAVIGATION_TABS_RIGHT_ARROW_CLASS);

  let activeTab = null;

  const sectionsMap = {
    overview: '.ao-tour-below-top',
    itinerary: '.js-ao-tour-itinerary',
    brochure: '.js-ao-tour-read-later-cta-banner',
    included: '.js-ao-tour-included',
    accommodation: '.js-ao-tour-where-stay',
    operator: '.ao-sustainability-operator-title',
    reviews: '.js-ao-tour-reviews',
    availability: '.js-ao-tour-availability',
    faqs: '.js-ao-tour-faq',
  };

  /**
   * Sets the active tab and updates the visual appearance of the navigation tabs.
   *
   * @param {string|HTMLElement|jQuery} tab - The tab to be set as active.
   * @param {boolean} [scrollIntoView=true] - Whether to scroll the active tab into view.
   * @returns {void}
   */
  const setActiveTab = (tab, scrollIntoView = true) => {
    const $currentTab = $(activeTab);
    const $newTab = $(tab);

    if ($currentTab.length) {
      $currentTab.closest(NAVIGATION_TAB_PARENT_CLASS).find(NAVIGATION_TAB_ACTIVE_CLASS).toggleClass('am-switch__marker-active');
      $currentTab.removeAttr('checked');
    }

    $newTab.closest(NAVIGATION_TAB_PARENT_CLASS).find(NAVIGATION_TAB_ACTIVE_CLASS).toggleClass('am-switch__marker-active');
    $newTab.attr('checked', true);
    activeTab = tab;

    // Scroll the active tab into view if it's out of the visible area
    const newTabElement = $newTab[0];
    if (newTabElement && scrollIntoView) {
      newTabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  };

  /**
   * Handles the click event on a tab.
   *
   * @param {string} tab - The tab to activate after the click event.
   * @returns {void}
   */
  const handleTabClick = (tab) => {
    const targetSection = $(tab).attr('value');

    if (targetSection) {
      const offset = targetSection === 'brochure' ? 300 : 100;
      const touchOffset = targetSection === 'brochure' ? 300 : 70;

      if (targetSection === 'brochure' && $('.js-ao-tour-read-later-cta-banner__button').length > 0) {
        setTimeout(() => {
          $('.js-ao-tour-read-later-cta-banner__button').click();
        }, 300);
      }

      const isTouchDevice = getDeviceType() === 'mobile' || getDeviceType() === 'tablet';
      if (!isTouchDevice) {
        navigationHandler.goTo(targetSection, '', '', offset);
        return;
      }
      const anchor = navigationHandler.mapToAnchor[targetSection];
      const $anchorElement = $(`.${anchor}`);
      if ($anchorElement.length > 0) navigationHandler.scroll($anchorElement, 0, touchOffset);
      else navigationHandler.goTo(targetSection, '', '', offset);
    }

    setActiveTab(tab);

    if (targetSection) {
      sendAmplitudeEvent({
        ampEventName: 'tdp_tabs_clicked',
        tab_element: targetSection,
      });
    }
  };

  /**
   * Scrolls the tabs in the specified direction.
   *
   * @param {string} direction - The direction in which to scroll the tabs.
   */
  const scrollTabs = (direction) => {
    if (!$switchWrapper.length) return;

    const switchWrapperElement = $switchWrapper[0];
    const scrollAmount = 200;

    if (direction === 'left') {
      switchWrapperElement.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth',
      });
    } else if (direction === 'right') {
      switchWrapperElement.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  /**
   * Updates the shadow classes of the navigation wrapper based on the scroll position of the switch wrapper.
   * The navigation wrapper must have the class ".am-switch__wrapper".
   * The shadow classes are added or removed based on the current scroll position of the switch wrapper.
   *
   * @function handleTabsScroll
   */
  const handleTabsScroll = () => {
    if (!$switchWrapper.length) return;

    const switchWrapperElement = $switchWrapper[0];
    const { scrollLeft } = switchWrapperElement;
    const maxScrollLeft = switchWrapperElement.scrollWidth - switchWrapperElement.clientWidth;

    if (switchWrapperElement.scrollWidth > switchWrapperElement.clientWidth) {
      if (scrollLeft > 0 && scrollLeft < maxScrollLeft) {
        $navWrapper.addClass('ao-tour-navigation-tabs--has-left-shadow ao-tour-navigation-tabs--has-right-shadow');
        $leftNavigationArrow.show();
        $rightNavigationArrow.show();
      } else if (scrollLeft === 0) {
        $navWrapper.addClass('ao-tour-navigation-tabs--has-right-shadow').removeClass('ao-tour-navigation-tabs--has-left-shadow');
        $leftNavigationArrow.hide();
        $rightNavigationArrow.show();
      } else if (scrollLeft === maxScrollLeft) {
        $navWrapper.addClass('ao-tour-navigation-tabs--has-left-shadow').removeClass('ao-tour-navigation-tabs--has-right-shadow');
        $leftNavigationArrow.show();
        $rightNavigationArrow.hide();
      }
    } else {
      $navWrapper.removeClass('ao-tour-navigation-tabs--has-left-shadow ao-tour-navigation-tabs--has-right-shadow');
      $leftNavigationArrow.hide();
      $rightNavigationArrow.hide();
    }

    $leftNavigationArrow.on('click', () => scrollTabs('left'));
    $rightNavigationArrow.on('click', () => scrollTabs('right'));
  };

  /**
   * Handles the scroll event and performs necessary actions based on the current scroll position.
   * If a section is scrolled to the top half of the viewport, it sets that section as the current section.
   * If the current section has a corresponding tab in the navigation menu, it sets that tab as active.
   * Handles sticky behavior of the navigation menu based on the scroll position of the parent element.
   *
   * @returns {void}
   */
  const handleScroll = () => {
    let currentSection = null;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    $.each(sectionsMap, (key, selector) => {
      const section = $(selector)[0];

      if (!section) return;

      const rect = section.getBoundingClientRect();

      if ((rect.top >= 0 && rect.top < viewportHeight / 2)
        || (rect.bottom >= viewportHeight / 2 && rect.bottom <= viewportHeight)) {
        currentSection = key;
      }
    });

    if (currentSection) {
      const matchingTab = $(`${NAVIGATION_TAB_SELECTOR}[value="${currentSection}"]`);

      if (matchingTab.length) {
        setActiveTab(matchingTab[0]);
      }
    }

    // Handle sticky behavior
    if ($parentElement.length && $navWrapper.length) {
      const parentRect = $parentElement[0].getBoundingClientRect();
      const navWrapperHeight = $navWrapper[0].getBoundingClientRect().height;

      if (parentRect.top <= 0 && parentRect.bottom > navWrapperHeight) {
        $navWrapper.addClass(NAVIGATION_TAB_STICKY_CLASS);
      } else {
        $navWrapper.removeClass(NAVIGATION_TAB_STICKY_CLASS);
      }
    }
  };

  const initiateTabSelectors = () => {
    $(NAVIGATION_TAB_PARENT_CLASS).each((index, tabParent) => {
      const tab = $(tabParent).find(NAVIGATION_TAB_SELECTOR)[0];

      if (!tab) return;

      const matchingSection = $(sectionsMap[tab.id]);

      // Hide tabs without existing matching sections.
      if (matchingSection.length) {
        $(tabParent).on('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          handleTabClick(tab);
        });
      } else {
        $(tabParent).hide();
      }

      // Refresh the tabs scroll arrows and shadow based on new items.
      handleScroll();
    });

    setActiveTab($navigationTabs[0], false);
  };

  const initiate = () => {
    initiateTabSelectors();
    $(window).on('scroll', handleScroll);

    // Adding a set timeout to handle the elements being removed affecting the arrows
    setTimeout(() => {
      $switchWrapper.on('scroll', handleTabsScroll);
      handleTabsScroll();
    }, 200);
  };

  return {
    initiate,
  };
}
